import { goBack, push } from "connected-react-router";
import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { IconButton } from "../../../components/IconButton";
import { LikeButton } from "./LikeButton";
import { OtherMenu } from "./OtherMenu";
import { ShareButton } from "./ShareButton";
import { MapMenu } from "./MapMenu";
import { useSSelector } from "../../../util";

type Props = {
  returnUrl: string;
  liked?: boolean;
  location?: any;
  fieldKey?: any;
  cropfield?: any;
};

export const HeaderButtons = (props: Props) => {
  const { returnUrl, liked, location, fieldKey, cropfield } = props;
  const activeFilter = useSSelector((s) => s.searchFilter);
  const dispatch = useDispatch();

  const close = useCallback(() => {
    if (activeFilter) {
      dispatch(goBack());
    } else {
      dispatch(push("/"));
    }
  }, [dispatch, activeFilter]);

  const pushToReturnUrl = useCallback(() => dispatch(push(`${returnUrl}`)), [returnUrl, dispatch]);

  return (
    <div className="header--button-container">
      <div className="button-group">
        {returnUrl && <IconButton icon="arrow-left" onClick={pushToReturnUrl} />}
        <LikeButton liked={liked} location={location} fieldKey={fieldKey} />
        <MapMenu cropfield={cropfield} location={location} />
        <ShareButton />
        <OtherMenu className="d-none d-md-block" cropfield={cropfield} />
      </div>
      <div className="button-group">
        <IconButton icon="times" onClick={close} />
      </div>
    </div>
  );
};
